var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 95,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 2c1-2 5-2 6 0l12 26 3 2 28 4c3 0 4 4 2 5L76 59l-1 3 5 29c1 2-2 4-4 3L50 80h-2L22 94c-2 1-5-1-4-3l5-29-1-3L1 39c-2-1-1-5 2-5l28-4 3-2L46 2Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelIcon);
export default __webpack_public_path__ + "static/media/level-icon.f708220247c97809bc78d1bb4bcbb1c2.svg";
export { ForwardRef as ReactComponent };